import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { BookOpen, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-sm animate-fade-up" data-testid="forgot-password-page">
        <div className="flex items-center gap-2 font-display text-2xl font-semibold mb-8">
          <BookOpen className="text-primary" /> Khata
        </div>
        {sent ? (
          <div className="rounded-xl border border-border bg-card p-6 text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto mb-3 text-[hsl(var(--positive))]" size={36} />
            <h1 className="font-display text-2xl font-semibold">Check your inbox</h1>
            <p className="text-muted-foreground text-sm mt-2">
              If an account exists for <span className="num">{email}</span>, we've sent a password
              reset link. It expires in 1 hour.
            </p>
            <Link to="/login" className="inline-flex items-center gap-1.5 mt-5 text-sm text-primary hover:underline">
              <ArrowLeft size={14} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h1 className="font-display text-3xl font-semibold">Forgot password</h1>
            <p className="text-muted-foreground text-sm mt-1 mb-8">
              Enter your email and we'll send you a reset link.
            </p>
            <label className="block text-sm font-medium mb-1.5">Email</label>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 px-3 rounded-md border border-input bg-card text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-ring/40"
              placeholder="you@company.com"
            />
            {error && <p data-testid="forgot-error" className="text-destructive text-sm mb-2">{error}</p>}
            <button
              data-testid="forgot-submit"
              disabled={loading}
              className="mt-4 w-full h-11 rounded-md bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors disabled:opacity-60"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" className="inline-flex items-center gap-1.5 mt-5 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft size={14} /> Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
